<template>
  <div>
    <NavBar />
    <modal name="modalComunicados" height="auto" width="900" :scrollable="true" :clickToClose="false">
      <div class="modalbox">
        <div class="modalbox-content">
          <div class="row">
            <ul class="tabs">
              <li class="tab-active">
                <a href="#/">Novo comunicado</a>
              </li>
            </ul>
          </div>
          <div class="row">

          <button class="button button-primary " style='margin-top: 20px' v-on:click="modeCode=!modeCode" >Modo <span v-show="!modeCode">Código</span> <span v-show="modeCode">Editor</span> </button>
              
            <form class="form" action="">
              <div class="col-1">
                <div class="form-group">
                  <label for="">Título</label>
                  <vue-editor id="editor1" v-if="!modeCode" v-model="modalTitulo" :editorToolbar="customToolbar"></vue-editor>

                  <div class="row"  style="margin-bottom: 20px; " v-if="modeCode">
                    <textarea style='width: 100%; height: 100px' v-model="modalTitulo"></textarea>
                  </div>
                  <div class="message">{{ validation.firstError('modalTitulo') }}</div>
                </div>
                
              </div>
              <div class="col-1">
                <div class="form-group">
                  <label for="">Descrição</label>
                  <vue-editor id="editor2" v-model="modalDescricao"   v-if="!modeCode" :editorToolbar="customToolbar"></vue-editor>
                  <div class="row"  style="margin-bottom:  20px; " v-if="modeCode">
                    <textarea style='width: 100%; height: 300px' v-model="modalDescricao"></textarea>
                  </div>
                  <div class="message">{{ validation.firstError('modalDescricao') }}</div>
                </div>
              </div>
              <div class="col-1-2">
                <div class="form-group">
                  <label for="">Data inicial</label>
                  <input type="date" name="" value="" v-model="modalInicio" class="form-control" required>
                </div>
              </div>
              <div class="col-1-2">
                <div class="form-group">
                  <label for="">Data final</label>
                  <input type="date" name="" value="" v-model="modalFinal" class="form-control" required>
                </div>
              </div>
              <div class="col-1">
                <button type="button" name="button" class="button button-lg button-success" v-on:click="salvaconfirm">Salvar</button>
                &nbsp;
                <button type="button" name="button" class="button button-lg button-secundary" v-on:click="hide">Fechar</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </modal>
    <div class="container">
      <SideBar />     
      <div class="content">
        <div class="content-wrapper">
          <Loading :isActive="loading"></Loading>
          <h1 class="title">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <path d="M449.511,137.648v-82.38c0-9.072-4.668-17.227-12.487-21.814c-7.849-4.605-17.29-4.7-25.251-0.247 c-76.024,42.516-158.725,67.345-245.805,73.802c-0.667,0.049-79.372,0.393-79.372,0.393c-19.767,0-36.105,14.923-38.366,34.091 H32.075C14.39,141.493,0,155.881,0,173.567v70.468c0,17.686,14.39,32.075,32.075,32.075h16.153 c1.628,13.795,10.544,25.383,22.785,30.799l57.485,158.648c3.593,9.875,13.067,16.511,23.578,16.511h57.687 c8.178,0,15.86-3.999,20.551-10.697c4.691-6.7,5.822-15.287,3.03-22.96l-49.389-136.237 c80.482,8.361,157.039,32.601,227.817,72.183c3.905,2.184,8.166,3.273,12.42,3.273c4.417-0.001,8.83-1.175,12.829-3.521 c7.819-4.588,12.489-12.742,12.489-21.816v-82.38C484.711,275.353,512,245.204,512,208.781 C512,172.357,484.711,142.207,449.511,137.648z M47.951,251.372H32.075c-4.047,0-7.338-3.291-7.338-7.338v-70.467 c0-4.044,3.291-7.337,7.338-7.337h15.876V251.372z M80.93,284.245c-4.85-2.174-8.242-7.039-8.242-12.688V146.044h0.001 c0-7.667,6.239-13.905,13.906-13.905h67.333v153.324c0,0-67.92-0.026-68.213-0.044C83.234,285.132,82.712,285.004,80.93,284.245z M210.091,456.853c0.04,0.101,0.066,0.173-0.041,0.324c-0.105,0.151-0.183,0.151-0.288,0.151h-57.687 c-0.147,0-0.282-0.093-0.327-0.215L98.515,310.199h58.411L210.091,456.853z M424.774,362.294c0,0.179,0,0.322-0.267,0.479 c-0.318,0.184-0.508,0.079-0.66-0.006c-76.034-42.52-158.469-68.045-245.182-75.96v-156.04 c86.72-7.927,169.155-33.454,245.179-75.97c0.156-0.085,0.349-0.19,0.663-0.006c0.267,0.157,0.267,0.298,0.267,0.477V362.294z M449.511,254.873v-92.185c21.503,4.314,37.752,23.339,37.752,46.092C487.263,231.534,471.013,250.56,449.511,254.873z"/></svg>
            Comunicados
          </h1>
          <ul class="tabs">
            <li class="tab-active">
              <router-link to="/comunicados">Dados</router-link>
            </li>
          </ul>
          <div class="card">
            <div class="card-body">
              <div class="filters row" style="margin-top:0">
                <div class="col-1">
                  <span class="filters__search">
                    <input type="text" name="" value="" placeholder="Buscar por..." v-model="termo">
                    <img style="position: relative;top: -7px; right: -10px;"src="data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDU2Ljk2NiA1Ni45NjYiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDU2Ljk2NiA1Ni45NjY7IiB4bWw6c3BhY2U9InByZXNlcnZlIiB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4Ij4KPHBhdGggZD0iTTU1LjE0Niw1MS44ODdMNDEuNTg4LDM3Ljc4NmMzLjQ4Ni00LjE0NCw1LjM5Ni05LjM1OCw1LjM5Ni0xNC43ODZjMC0xMi42ODItMTAuMzE4LTIzLTIzLTIzcy0yMywxMC4zMTgtMjMsMjMgIHMxMC4zMTgsMjMsMjMsMjNjNC43NjEsMCw5LjI5OC0xLjQzNiwxMy4xNzctNC4xNjJsMTMuNjYxLDE0LjIwOGMwLjU3MSwwLjU5MywxLjMzOSwwLjkyLDIuMTYyLDAuOTIgIGMwLjc3OSwwLDEuNTE4LTAuMjk3LDIuMDc5LTAuODM3QzU2LjI1NSw1NC45ODIsNTYuMjkzLDUzLjA4LDU1LjE0Niw1MS44ODd6IE0yMy45ODQsNmM5LjM3NCwwLDE3LDcuNjI2LDE3LDE3cy03LjYyNiwxNy0xNywxNyAgcy0xNy03LjYyNi0xNy0xN1MxNC42MSw2LDIzLjk4NCw2eiIgZmlsbD0iIzAwNDE2ZiIvPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K" />
                  </span>
                </div>
              </div>
              <table class="table">
                <thead>
                  <tr>
                    <th>Título</th>
                    <th>Data inicial</th>
                    <th>Data final</th>
                    <th>Ativo</th>
                    <th>
                      <button class="button button-success button-sm button-block" v-on:click="show()">
                        <svg style="width: 12px; height: 12px; fill: #fff;" x="0px" y="0px" viewBox="0 0 42 42"> <path d="M37.059,16H26V4.941C26,2.224,23.718,0,21,0s-5,2.224-5,4.941V16H4.941C2.224,16,0,18.282,0,21s2.224,5,4.941,5H16v11.059 C16,39.776,18.282,42,21,42s5-2.224,5-4.941V26h11.059C39.776,26,42,23.718,42,21S39.776,16,37.059,16z"/> </svg>
                        Novo
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="comunicado in filtro()">
                    <td class="highlight" v-html="comunicado.titulo"></td>
                    <td>
                      {{comunicado.dataInicio.slice(8, 10)}}/{{comunicado.dataInicio.slice(5, 7)}}/{{comunicado.dataInicio.slice(0, 4)}}
                    </td>
                    <td>{{comunicado.dataFinal.slice(8, 10)}}/{{comunicado.dataFinal.slice(5, 7)}}/{{comunicado.dataFinal.slice(0, 4)}}</td>
                    <td>
                      <span class="label success" v-if="comunicado.dataInicio <= dataHj && comunicado.dataFinal >= dataHj">Ativo</span>
                      <span class="label warning" v-else>Inativo</span>
                    </td>
                    <td class="actions">
                      <button type="button" class="button button-primary" v-on:click="show(comunicado._id)"><img src="data:image/svg+xml;utf8;base64,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" /></button>
                      &nbsp;
                      <button type="button" name="button" v-on:click="deleteConfirm(comunicado._id)" class="button button-error"><img src="data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUwOC41MiA1MDguNTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUwOC41MiA1MDguNTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIiB3aWR0aD0iNTEycHgiIGhlaWdodD0iNTEycHgiPgo8Zz4KCTxnPgoJCTxnPgoJCQk8Zz4KCQkJCTxwYXRoIGQ9Ik0zOTcuMjgxLDMxLjc4MmgtNjMuNTY1QzMzMy43MTYsMTQuMjM5LDMxOS40NzgsMCwzMDEuOTM0LDBoLTk1LjM0NyAgICAgIGMtMTcuNTQ0LDAtMzEuNzgyLDE0LjIzOS0zMS43ODIsMzEuNzgyaC02My41NjVjLTE3LjU0NCwwLTMxLjc4MiwxNC4yMzktMzEuNzgyLDMxLjc4MmgzNDkuNjA3ICAgICAgQzQyOS4wNjMsNDYuMDIxLDQxNC44MjUsMzEuNzgyLDM5Ny4yODEsMzEuNzgyeiIgZmlsbD0iI0ZGRkZGRiIvPgoJCQkJPHBhdGggZD0iTTc5LjQ1Niw0NzYuNzM3YzAsMTcuNTQ0LDE0LjIzOSwzMS43ODIsMzEuNzgyLDMxLjc4MmgyODYuMDQyICAgICAgYzE3LjU0NCwwLDMxLjc4Mi0xNC4yMzksMzEuNzgyLTMxLjc4MlY5NS4zNDdINzkuNDU2VjQ3Ni43Mzd6IE0zMzMuNzE2LDE3NC44MDRjMC04Ljc3Miw3LjE1MS0xNS44OTEsMTUuODkxLTE1Ljg5MSAgICAgIGM4Ljc0LDAsMTUuODkxLDcuMTE5LDE1Ljg5MSwxNS44OTF2MjU0LjI2YzAsOC43NC03LjE1MSwxNS44OTEtMTUuODkxLDE1Ljg5MWMtOC43NCwwLTE1Ljg5MS03LjE1MS0xNS44OTEtMTUuODkxVjE3NC44MDR6ICAgICAgIE0yMzguMzY5LDE3NC44MDRjMC04Ljc3Miw3LjExOS0xNS44OTEsMTUuODkxLTE1Ljg5MWM4Ljc0LDAsMTUuODkxLDcuMTE5LDE1Ljg5MSwxNS44OTF2MjU0LjI2ICAgICAgYzAsOC43NC03LjE1MSwxNS44OTEtMTUuODkxLDE1Ljg5MWMtOC43NzIsMC0xNS44OTEtNy4xNTEtMTUuODkxLTE1Ljg5MVYxNzQuODA0eiBNMTQzLjAyMSwxNzQuODA0ICAgICAgYzAtOC43NzIsNy4xMTktMTUuODkxLDE1Ljg5MS0xNS44OTFjOC43NzIsMCwxNS44OTEsNy4xMTksMTUuODkxLDE1Ljg5MXYyNTQuMjZjMCw4Ljc0LTcuMTE5LDE1Ljg5MS0xNS44OTEsMTUuODkxICAgICAgYy04Ljc3MiwwLTE1Ljg5MS03LjE1MS0xNS44OTEtMTUuODkxVjE3NC44MDR6IiBmaWxsPSIjRkZGRkZGIi8+CgkJCTwvZz4KCQk8L2c+Cgk8L2c+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==" /></button>
                    </td>
                  </tr>
                </tbody>
              </table>              
            </div>
          </div>
        </div>
      </div>
      </SideBar>
    </div>
  </div>
</template>
<script>
import { Validator } from 'simple-vue-validator'
import { get, post, put, del } from '../../helpers/apiRequest'
import { customToolbar } from '@/helpers/utils'

const url = '/comunicados'

export default {
  name: 'comunicados',
  data () {
    return {
      customToolbar: customToolbar(),
      size: '50px',
      loading: false,
      comunicados: [],
      modalTitulo: '',
      modalDescricao: '',
      modalInicio: '',
      modalFinal: '',
      modalTipo: 'comunicado',
      modalId: '',
      dataHj: '',
      modalAtivo: false,
      termo: '',
      msg: {
        text: 'Comunicados',
        status: ''
      },
      isDisabled: true,
      alertLeave: false,
       modeCode: false
    }
  },
  validators: {
    modalTitulo: function (value) {
      const d1 = this.modalTitulo
      if (d1 !== value) {
        this.validaCampos()
      } else {
        this.clear()
      }
      return Validator.value(value).required()
    },
    modalDescricao: function (value) {
      const d1 = this.modalDescricao
      if (d1 !== value) {
        this.validaCampos()
      } else {
        this.clear()
      }
      return Validator.value(value).required()
    }
  },
  methods: {
    formatDate() {
        var d = new Date(),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    },
    filtro () {
      return this.comunicados.filter(i => ['titulo', 'dataInicio'].some(k => i[k].toLowerCase().match(this.termo.toLowerCase())))
    },
    show (id) {
      if (id) {
        const data = this.comunicados
        const data2 = data.filter(n => {
          return n._id === id
        })
        this.modalTitulo = data2[0].titulo
        this.modalDescricao = data2[0].descricao
        this.modalAtivo = data2[0].ativo
        this.modalTipo = data2[0].tipo
        this.modalInicio = data2[0].dataInicio
        this.modalFinal = data2[0].dataFinal
        this.modalId = id
        this.$modal.show('modalComunicados')
      } else {
        this.$modal.show('modalComunicados')
      }
    },
    hide () {
      this.$modal.hide('modalComunicados')
      this.modalId = ''
      this.modalInicio = ''
      this.modalDescricao = ''
      this.modalTitulo = ''
      this.modalAtivo = false
    },
    clear () {
      // this.msg.text = 'Comunicados'
      // this.msg.status = ''
      // this.isDisabled = true
      // this.alertLeave = false
    },
    salvaCategoria () {
      const novoCom = {
        'titulo': this.modalTitulo,
        'tipo': this.modalTipo,
        'descricao': this.modalDescricao,
        'dataFinal': this.modalFinal,
        'dataInicio': this.modalInicio
      }
      if (this.modalId) {
        put(`${url}/${this.modalId}`, novoCom)
          .then(json => {
            if (json.message === 'jwt expired') {
              this.$swal('Por favor, faça o login novamente')
              this.alertLeave = false
              this.$router.push('/login')
            }
            if (json.errors) {
              this.$swal('Todos os campos devem ser preenchidos corretamente')
            } else {
              const data = this.comunicados
              data.map(n => {
                if (n._id === this.modalId) {
                  n.titulo = this.modalTitulo
                  n.descricao = this.modalDescricao
                  n.ativo = this.modalAtivo
                  n.tipo = this.modalTipo
                  n.dataInicio = this.modalInicio
                  n.dataFinal = this.modalFinal
                }
              })
              this.hide()
              this.$swal({title: 'Alterado com Sucesso! ', type: 'success' })
            }
          })
      } else {
        post(url, novoCom)
          .then(json => {
            this.comunicados.push(json)
            this.hide()
            this.$swal({title: 'Inserido com Sucesso! ', type: 'success' })
          })
      }
    },
    criaData () {
      const dateObj = new Date()
      const month = ('0' + (dateObj.getMonth() + 1)).slice(-2)
      const date = ('0' + dateObj.getDate()).slice(-2)
      const year = dateObj.getFullYear()
      const shortDate = year + '-' + month + '-' + date
      return shortDate
    },
    update: function () {
      put(`${url}/${this.comunicados._id}`, this.comunicados)
        .then(json => {
          if (json.message === 'jwt expired') {
            this.$swal('Por favor, faça o login novamente')
            this.$router.push('/login')
          }
          this.msg.text = 'Alterações concluídas'
          this.msg.status = 'success'
          this.isDisabled = true
          this.alertLeave = false
          this.loading = false
        })
    },
    deleteConfirm (id) {
      this.$swal({ title: 'Confirma Remover ?', showCancelButton: true, type: 'error', confirmButtonColor: '#d82727' })
        .then(() => {
          this.deleteCategoria(id)
        }, () => {})
    },
    salvaconfirm () {
      this.salvaCategoria()
    },
    deleteCategoria (id) {
      del(`${url}/${id}`)
        .then(json => {
          const data = this.comunicados
          const data2 = data.filter(n => {
            return n._id !== id
          })
          this.comunicados = data2
        })
    },
    clickHandler () {
      const thiss = this
      this.$swal({title: 'Deseja salvar alterações?', showCancelButton: true}).then(
        function (result) {
          thiss.update()
          thiss.loading = true
        }, function (dismiss) {
        thiss.clear()
      }
      )
    }
  },
  beforeMount () {
    this.dataHj = this.formatDate()
    this.loading = true
    get(url)
      .then(json => {
        this.comunicados = json
        this.loading = false
      })
  },
  beforeRouteLeave: function (to, from, next) {
    const thiss = this
    if (this.alertLeave === true) {
      this.$swal({title: 'Existem dados a serem salvos, deseja sair?', showCancelButton: true}).then(
          function (result) {
            thiss.alertLeave = false
            next()
          }, function (dismiss) {
        console.log('nada salvo')
      }
        )
    } else {
      next()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Comunicados/Comunicados.vue